import * as styles from './styles.css';
import { Image, useDeviceType } from '@cian/ui-kit';
import { Typography } from '../Typography';
import * as React from 'react';
import errorImg from '../../assets/images/error.png';
import { FC, ReactNode } from 'react';
import cn from 'clsx';

interface IErrorMessage {
  title: string;
  description: string;
  controls?: ReactNode;
}

export const ErrorMessage: FC<IErrorMessage> = ({ title, controls, description }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  return (
    <div className={cn(styles['container'], styles[deviceType])}>
      <Image src={errorImg} width={isDesktop ? 300 : 200} />
      <div className={cn(styles['description'], styles[deviceType])}>
        {isDesktop ? (
          <Typography.Title level={3}>{title}</Typography.Title>
        ) : (
          <Typography.Title level={5}>{title}</Typography.Title>
        )}
        {isDesktop ? (
          <Typography.Text level={2}>{description}</Typography.Text>
        ) : (
          <Typography.Text level={3}>{description}</Typography.Text>
        )}
      </div>
      {controls && <div className={cn(styles['controls'], styles[deviceType])}>{controls}</div>}
    </div>
  );
};
